module.exports = __webpack_public_path__ + "img/globe-icon.fba6b71a.svg";